'use es6';

import { createSelector } from 'reselect';
import get from 'transmute/get';
import { getWelcomeMessage } from './getWelcomeMessage';
export const getMessageId = createSelector(getWelcomeMessage, get('id'));